import { combineReducers } from 'redux';
import authReducer from './ducks/auth/reducers';
import notificationReducer from './ducks/notification/reducers';
import userReducer from './ducks/user/reducers';
import langReducer from './ducks/langs/reducers';

export default combineReducers({
	authReducer,
	notificationReducer,
	userReducer,
	langReducer,
});
